export { GamepadPlatformPage } from './platform';
